<template>
    <div class="d-flex align-center">
        <router-link
            v-if="useCompanyPdfLogo"
            to="/"
            class="text-decoration-none d-flex align-center"
        >
            <v-img
                :src="pdfLogoDataUrl"
                alt=""
                contain
                max-height="34"
                max-width="150"
                class="company-toolbar-logo flex-grow-0"
            />
        </router-link>
        <template v-else>
            <logo-toolbar />
            <title-toolbar />
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { LogoToolbar, TitleToolbar } from '@dracul/customize-frontend'

export default {
    name: 'CompanyToolbarBranding',
    components: { LogoToolbar, TitleToolbar },
    computed: {
        ...mapState('companyBranding', ['pdfLogoDataUrl', 'hasPdfLogo', 'loaded']),
        useCompanyPdfLogo() {
            return this.loaded && this.hasPdfLogo && !!this.pdfLogoDataUrl
        },
    },
}
</script>

<style scoped>
.company-toolbar-logo {
    min-width: 60px;
}
</style>
